import cssVariablesTheme from 'foundations-theming/css-vars-theme';
const Colors = cssVariablesTheme.color;
export let ColorThemeOption;
(function (ColorThemeOption) {
  ColorThemeOption["OrangeLight"] = "ORANGE_LIGHT";
  ColorThemeOption["YellowLight"] = "YELLOW_LIGHT";
})(ColorThemeOption || (ColorThemeOption = {}));
export const defaultColorOptions = {
  innerBlobColor: Colors['fill-accent-yellow-hover'],
  outerBlobColor: Colors['fill-accent-yellow-subtle'],
  smallDecorativeBlobColor: Colors['fill-accent-yellow-default']
};
export const ColorTheme = new Map([[ColorThemeOption.OrangeLight, {
  innerBlobColor: Colors['fill-accent-light-orange-hover'],
  outerBlobColor: Colors['fill-accent-light-orange-subtle'],
  smallDecorativeBlobColor: Colors['fill-accent-light-orange-default']
}], [ColorThemeOption.YellowLight, {
  innerBlobColor: Colors['fill-accent-yellow-hover'],
  outerBlobColor: Colors['fill-accent-yellow-subtle'],
  smallDecorativeBlobColor: Colors['fill-accent-yellow-default']
}]]);